import * as React from "react";
import { getDefPromt, setDefPromt } from "./lib/utility";

let deferredPrompt = null;

export function useAddToHomescreenPrompt() {
  const [prompt, setPrompt] = React.useState(getDefPromt() || deferredPrompt);

  const promptToInstall = React.useCallback(async () => {
    const installPrompt = prompt || getDefPromt() || deferredPrompt;

    if (!installPrompt) {
      throw new Error(
        'Tried installing before browser sent "beforeinstallprompt" event',
      );
    }

    await installPrompt.prompt();
    const userChoice = await installPrompt.userChoice;

    // The prompt event can only be used once; clear cached refs.
    deferredPrompt = null;
    setPrompt(null);
    setDefPromt(null);

    return userChoice;
  }, [prompt]);

  React.useEffect(() => {
    const ready = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setDefPromt(e);
      setPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", ready);

    return () => {
      window.removeEventListener("beforeinstallprompt", ready);
    };
  }, []);

  React.useEffect(() => {
    if (!prompt) {
      const cachedPrompt = getDefPromt() || deferredPrompt;
      if (cachedPrompt) {
        setPrompt(cachedPrompt);
      }
    }
  }, [prompt]);

  return [prompt, promptToInstall];
}
